import { Dependee, UIFilter } from "@reflag/shared/filter";
import { UsersBody, UsersCountBody } from "@reflag/shared/userAPI";

const qk = {
  bootstrap: (orgId?: string) => ["bootstrap", orgId] as const,
  orgs: ["orgs"] as const,

  orgInvite: (orgId?: string, inviteKey?: string) =>
    [...qk.orgs, orgId, "invites", inviteKey] as const,

  root: (appId?: string, envId?: string) => [
    "apps",
    appId,
    "environments",
    envId,
  ],

  distinctEventNames: (appId?: string, envId?: string) =>
    [...qk.root(appId, envId), "distinctEventNames"] as const,

  users: (appId?: string, envId?: string, params?: Omit<UsersBody, "envId">) =>
    [...qk.root(appId, envId), "users", ...(params ? [params] : [])] as const,

  usersCount: (
    appId?: string,
    envId?: string,
    params?: Omit<UsersCountBody, "envId">,
  ) =>
    [
      ...qk.root(appId, envId),
      "users",
      "count",
      ...(params ? [params] : []),
    ] as const,

  user: (appId?: string, envId?: string, userId?: string) =>
    [...qk.root(appId, envId), "users", userId] as const,

  userNames: (appId?: string, envId?: string, ids?: string[]) =>
    [...qk.root(appId, envId), "user-names", ...(ids ?? [])] as const,

  companyAttributeValues: (
    appId?: string,
    envId?: string,
    params?: Record<string, string | undefined>,
  ) =>
    [
      ...qk.root(appId, envId),
      "companyAttributeValues",
      ...(params ? [params] : []),
    ] as const,

  eventAttributeValues: (
    appId?: string,
    envId?: string,
    entityValue?: string,
    attributeKey?: string,
    search?: string,
  ) =>
    [
      ...qk.root(appId, envId),
      "eventAttributeValues",
      entityValue,
      attributeKey,
      search,
    ] as const,

  eventAttributeNames: (appId?: string, envId?: string, eventName?: string) =>
    [...qk.root(appId, envId), "eventAttributeNames", eventName] as const,

  filterCheck: (appId?: string, dependee?: Dependee, filter?: UIFilter) =>
    [
      "apps",
      appId,
      "filter-check",
      dependee,
      ...(filter ? [filter] : []),
    ] as const,

  linearConnection: (orgId?: string) => ["linearConnection", orgId] as const,
  slackConnection: (orgId?: string) => ["slackConnection", orgId] as const,
};

export { qk as commonQueryKeys };
